import { nothing } from 'lit';
import { AsyncDirective } from 'lit/async-directive.js';
import { directive, PartType } from 'lit/directive.js';
import { isFunction, isNil, isString } from '../../utils/unit';
import { listen as listenToEvent } from '../events';
export class EventListenerDirective extends AsyncDirective {
    constructor(partInfo) {
        super(partInfo);
        if (partInfo.type !== PartType.ELEMENT) {
            throw new Error('The `on` directive must be used on an element tag.');
        }
    }
    render(type, listener, options) {
        return nothing;
    }
    update(part, [type, listener, options]) {
        var _a, _b;
        if (this._element !== part.element ||
            this._type !== type ||
            this._listener !== listener ||
            this._options !== options ||
            this._host !== ((_a = part.options) === null || _a === void 0 ? void 0 : _a.host)) {
            this._element = part.element;
            this._type = type;
            this._listener = listener;
            this._options = options;
            this._host = (_b = part.options) === null || _b === void 0 ? void 0 : _b.host;
            this._removeEventListener();
            this._addEventListener();
        }
        return nothing;
    }
    _addEventListener() {
        var _a;
        if (isNil(this._element) ||
            !isString(this._type) ||
            !isFunction(this._listener)) {
            return;
        }
        this._dispose = listenToEvent(this._element, this._type, this._listener.bind((_a = this._host) !== null && _a !== void 0 ? _a : this._element), this._options);
    }
    _removeEventListener() {
        var _a;
        (_a = this._dispose) === null || _a === void 0 ? void 0 : _a.call(this);
        this._dispose = undefined;
    }
    reconnected() {
        this._addEventListener();
    }
    disconnected() {
        this._removeEventListener();
    }
}
/**
 * @param type - The name of the event to listen to.
 * @param listener - The function to be called when the event is fired.
 * @param options - Configures the event listener.
 */
export const on = directive(EventListenerDirective);
